import { useState, useEffect, useRef } from "react";
import { X, Trash2, ChevronDown, ChevronUp } from "lucide-react";

// Extend window to include debug log function
declare global {
  interface Window {
    __DEBUG_LOG__?: (message: string) => void;
  }
}

interface LogEntry {
  timestamp: Date;
  message: string;
}

export const DebugLogOverlay = () => {
  // Completely disabled - return null to hide the debug overlay
  return null;
};
